import { motion } from "framer-motion";
import PraiseLogo from "@/components/PraiseLogo";
import { Link } from "react-router-dom";

export const LandingFooter = () => {
  return (
    <footer className="bg-foreground text-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <PraiseLogo size={28} />
              <span className="font-editorial text-xl">Praise</span>
            </div>
            <p className="text-background/70 text-sm">
              Transform testimonials into marketing assets.
            </p>
          </div>

          <div>
            <p className="specimen-label text-background/70 mb-4">Product</p>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-background/70 hover:text-background transition-colors">Features</Link></li>
              <li><Link to="/pricing" className="text-background/70 hover:text-background transition-colors">Pricing</Link></li>
              <li><Link to="/gallery" className="text-background/70 hover:text-background transition-colors">Examples</Link></li>
            </ul>
          </div>

          <div>
            <p className="specimen-label text-background/70 mb-4">Company</p>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="text-background/70 hover:text-background transition-colors">About</a></li>
              <li><a href="#" className="text-background/70 hover:text-background transition-colors">Blog</a></li>
              <li><a href="#" className="text-background/70 hover:text-background transition-colors">Contact</a></li>
            </ul>
          </div>

          <div>
            <p className="specimen-label text-background/70 mb-4">Support</p>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="text-background/70 hover:text-background transition-colors">Help Center</a></li>
              <li><a href="#" className="text-background/70 hover:text-background transition-colors">API Docs</a></li>
              <li><a href="#" className="text-background/70 hover:text-background transition-colors">Status</a></li>
            </ul>
          </div>
        </div>

        <motion.div
          className="h-px w-full bg-background/20 mb-8"
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true }}
        />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background/70 text-sm">
            &copy; {new Date().getFullYear()} Praise. All rights reserved.
          </p>
          <p className="text-background/70 text-sm">
            Built by{" "}
            <a
              href="https://bwestudios.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-background hover:text-brand-400 transition-colors font-medium"
            >
              BWE Studio
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};
